export default "__VITE_ASSET__d37eaf31__"